module.exports = __webpack_public_path__ + "assets/img/backall.ad738262.png";